import { Vue, Component } from "vue-property-decorator";
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

@Component({
    components: {
        Swiper,
        SwiperSlide
    }
})
export default class Video extends Vue {

  swiperOptions: any = {
    slidesPerView: 3,
    spaceBetween: 30,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  }

  persons: any[] = [
    {
      image: require('./yp-min.png'),
      linkedin: 'https://www.linkedin.com/in/yon-perullo-a00398/',
      name: 'Yon Perullo',
      post: 'Chief Executive Officer'
    },
    {
      image: require('./ds-min.png'),
      linkedin: 'https://www.linkedin.com/in/daniel-satchkov-3986421/',
      name: 'Daniel Satchkov',
      post: 'Founder, President'
    },
    {
      image: require('./astr-min.png'),
      linkedin: 'https://www.linkedin.com/in/alstarodubtsev/',
      name: 'Alexandr Starodubtsev',
      post: 'Director, Client Success'
    },
    {
      image: require('./valeryb-min.png'),
      linkedin: 'https://www.linkedin.com/in/joni-adair-1st-5b27278/',
      name: 'Joni Adair',
      post: 'Director, National Accounts'
    },
    {
      image: require('./val-min.png'),
      linkedin: 'https://www.linkedin.com/in/valentin-kolesov-9a1b931/',
      name: 'Valentin Kolesov',
      post: 'Director of Engineering at RiXtrema Inc.'
    }
  ]
  

}